import React, { FC }                                                                                                             from 'react';
import * as Yup                                                                                                                  from "yup";
import { Cell, Grid }                                                                                                            from "styled-css-grid";
import { BulkUpdateFormControlContainer }                                                                                        from "@src/views/pages/projects/activities/bulk/BulkUpdateFormControlContainer";
import { StaticProjectActivityBulkUpdateShell, StaticProjectActivityBulkUpdateShellFormContainerProps, StaticProjectActivityBulkUpdateShellProps } from "@src/views/pages/projects/activities/bulk/StaticProjectActivityBulkUpdateShell";
import { ProjectActivityBulkUpdateMultiDialogProps }                                                                             from "@src/views/pages/projects/operations/StaticProjectActivityBulkUpdateMultiDialog";
import { ACTIVITY_STATUS, ENTITY_ICONS }                                                                                         from "@src/constants";
import _                                                                                                                         from "underscore";
import { useFeatureFlags }                                                                                                       from "@src/hooks";
import { InteropService }                                                                                                        from "@src/services";
import { CompletionStatusDropdown }                                                                                              from "@src/views/components/forms/dropdowns/CompletionStatusDropdown";


type FormTypeAttributes = {
    completionState: ACTIVITY_STATUS,
}

const formDefaultValues = {
    completionState: null,
}

const validationSchema = (
    Yup.object().shape( {
        completionState: Yup.string().nullable()
    } )
)

const mutationAttributeFormatter: StaticProjectActivityBulkUpdateShellProps<FormTypeAttributes>['prepareFormValuesForMutation'] = ( values, formik ) => {

    const { completionState } = values

    const changes: Record<any, any> = {};

    if( !_.isEmpty( completionState ) ){
        changes.percentDone = InteropService.getActivityStatusToPercentDone( completionState );
    }

    return changes;
}

interface StaticProjectActivityBulkUpdateCompletionStateProps extends Pick<StaticProjectActivityBulkUpdateShellProps<FormTypeAttributes>, 'supportModals' | 'supportToasts'>,
    Pick<ProjectActivityBulkUpdateMultiDialogProps, 'projectId' | 'projectVersionId' | 'projectActivityIds'> {
    formContainer: FC<StaticProjectActivityBulkUpdateShellFormContainerProps>
}

const StaticProjectActivityBulkUpdateCompletionStateDefaultProps = {
    supportModals: false,
    supportToasts: true,
} satisfies Partial<StaticProjectActivityBulkUpdateCompletionStateProps>

function StaticProjectActivityBulkUpdateCompletionState( _props: StaticProjectActivityBulkUpdateCompletionStateProps ){

    const props = { ...StaticProjectActivityBulkUpdateCompletionStateDefaultProps, ..._props };

    const featureFlags = useFeatureFlags();

    return (

        <StaticProjectActivityBulkUpdateShell<FormTypeAttributes>
            projectId={ props.projectId }
            projectVersionId={ props.projectVersionId }
            ids={ props.projectActivityIds }
            supportToasts={ props.supportToasts }
            supportModals={ props.supportModals }
            defaultFormValues={ formDefaultValues }
            validationSchema={ validationSchema }
            formContainer={ props.formContainer }
            prepareFormValuesForMutation={ mutationAttributeFormatter }>

            {/* FORM CONTENT */ }
            { ( { formik, isProcessing, isLoading } ) => {

                return (

                    <BulkUpdateFormControlContainer
                        icon={ ENTITY_ICONS.ACTIVITIES.CRITICALITY_RATING }
                        title={ 'Update Completion Status' }
                        description={ `Migrate the completion status for multiple activities to the one specified.` }>

                        <Grid columns={ `1fr` } rows={ `auto auto` } columnGap={ "30px" } rowGap={ '30px' }>
                            <Cell>

                                <CompletionStatusDropdown
                                    label={ "Status" }
                                    descriptionText={ `The general status for which these activities should be set to.` }
                                    name={ "completionState" }
                                    omit={ [ ACTIVITY_STATUS.EXCLUDED ] }
                                    disabled={ isLoading || isProcessing }/>
                            </Cell>
                        </Grid>

                    </BulkUpdateFormControlContainer>

                )
            } }

        </StaticProjectActivityBulkUpdateShell>

    );
}

export {
    StaticProjectActivityBulkUpdateCompletionState,
    StaticProjectActivityBulkUpdateCompletionStateDefaultProps,
    type StaticProjectActivityBulkUpdateCompletionStateProps,
};
